<template>
  <div
    v-if="show.cheat === false"
    class="browse"
    :id="'browse_' + type"
  >
    <div class="flex wrap between align-center p8 label">
      <div class="flex between flexy align-center md-font b4">
        <b class>
          <i :class="$store.state.icons[type]" class></i>
          {{ type.toUpperCase() }}
        </b>
        <span v-if="$route.name === 'tags'" class="xs-font">
          Tagged with
          <code class="indicate-text">
            <i class="fas fa-hashtag"></i>
            {{ $route.params.tag }}
          </code>
        </span>
      </div>
      <div class="fill flex wrap align-center">
        <div class="flex wrap align-center flexy fill between xs-font">
          <input
            :id="'browse_' + type + '_search'"
            v-model="$store.state.search[type]"
            class="input-with-icon sm-font xs-input"
            :class="'browse_' + type + '_search'"
            type="text"
            :placeholder="'Search ' + type"
          />
          <span
            class="flex around align-center"
            :class="'browse_' + type + '_views'"
          >
            <h5>Views</h5>
            <a
              :class="
                show.view[type] === 'grid' ? 'update-text' : ''
              "
              href
              type="button"
              class="p4 r4"
              @click.prevent="$set(show.view, type, 'grid')"
            >
              <i class="fa fa-table fa-xs r4"></i> Grid
            </a>
            /
            <a
              :class="
                show.view[type] === 'list' ? 'update-text' : ''
              "
              href
              type="button"
              class="p4"
              @click.prevent="$set(show.view, type, 'list')"
            >
              <i class="fas fa-th-list fa-xs r4"></i>List
            </a>
            /
            <a
              :class="show.view[type] === 'post' ? 'update-text' : ''"
              class="p4"
              @click.prevent="
                $set(show.view, type, 'post');
                
              "
            >
              <i class="fas fa-th-list fa-xs r4"></i>Post
            </a>
          </span>
          <a
            :class="show.sorts ? 'update-text' : ''"
            href
            @click.prevent="show.sorts = !show.sorts"
            type="button"
            class="p4"
          >
            <i class="fa fa-sort r4"></i>Sort
          </a>
          <a
            :class="show.filters ? 'update-text' : ''"
            href
            @click.prevent="show.filters = !show.filters"
            type="button"
            class="p4"
          >
            <i class="fa fa-sort r4"></i>Filters
          </a>
          <div
            class="flex wrap align-center p8 around fill"
            v-if="show.sorts"
            :class="'browse_' + type + '_sort'"
          >
            <a
              href
              @click.prevent="sort(prop)"
              type="button"
              class="r4 xs-font b4"
              :key="propKey"
              v-for="(prop, propKey) in filterProps[type]"
            >
              <span
                :class="
                  $store.state.sorts[type] &&
                  $store.state.sorts[type][0] === prop
                    ? 'update-text'
                    : ''
                "
                class="r4 sm-font"
              >
                {{ prop.indexOf(".") > -1 ? prop.split(".")[1] : prop }}
                <i
                  class="fa-xs"
                  :class="
                    $store.state.sorts[type] &&
                    $store.state.sorts[type][0] === prop
                      ? $store.state.sorts[type][1] === 1
                        ? 'fas fa-sort-down'
                        : 'fas fa-sort-up'
                      : ''
                  "
                ></i>
              </span>
            </a>
          </div>
        </div>
        <!-- <div class="xs-font" v-if="show.filters">
            <b class="r16">Filter through: </b>
            <button @click="filter('clear')" type="button" class="r8">Clear Filters</button>
            <button @click="filterThrough.indexOf(prop) > -1 ? filterThrough.splice(filterThrough.indexOf(prop), 1) : filterThrough.push(prop); filter(filterThrough)" type="button" class="r8" :key="propKey" v-for="(prop, propKey) in filterProps[type]">{{prop}}</button>
          </div> -->
      </div>
    </div>
    <keep-alive> 
      <component
        :sort="$store.state.sorts[type] ? $store.state.sorts[type][1] : 1"
        :order="sortby"
        :limit="limit"
        :filter="filtr"
        :view="passview.view || 'list'"
        v-if="show.view[type]"
        :id="'ilist_' + type.norm()"
        :class="'ilist_' + type.norm()"
        class="ilist flex wrap"
        :key="type + passview.view"
        :is="'ilist'"
        :type="type"
        v-bind="passview"
      ></component>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "browse",
  computed: {
    passview(){
      return {view: this.show.view[this.type] || this.view || 'list'}
    },
    filterProps() {
      this.$set(this.filterProperties, this.type, []);
      this.$store.state.app.forms[this.type].forms.forEach((form) => {
        form.inputs.forEach((input) => {
           this.filterProperties[this.type].push(form.name + "." + input.label);
        });
      });
      this.$set(this.filterProperties, this.type, [
        ...this.filterProperties[this.type],
        "users",
        "created",
      ]);
      return this.filterProperties;
    }
  },
  data() {
    return {
      filterProperties: {},
      filterThrough: [],
      // order: '',
      filtr: {},
      show: {
        cheat: false,
        filters: false,
        sorts: false,
        view: {}
      },
      sortby: this.order || ''
    };
  },
  metaInfo() {
    return {
      title: this.type,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.$store.state.app.basics.mission || "XMBL App"
        },
      ],
    };
  },
  methods: {
    sort(prop) {
      if (prop === "clear") {
        return this.$delete(this.$store.state.sorts, this.type);
      }
      var direction =
        this.$store.state.sorts[this.type] &&
        this.$store.state.sorts[this.type][1] === 1
          ? -1
          : 1;
      this.$delete(this.$store.state.sorts, this.type);
      this.$set(this.$store.state.sorts, this.type, [prop, direction]);
      this.$set(this, 'sortby', false)
      this.$set(this, 'sortby', prop)
      return true
    },
    filter(propList) {
      if (propList === "clear") {
        return this.$set(this.$store.state.filters, this.type, false);
      }
      this.$set(this.$store.state.filters, this.type, propList);
    },
  },
  props: { type: { type: String }, limit: { type: String }, order: { type: String }, view: { type: String } },
  mounted() {
    this.$set(this.show.view, this.type, this.view || 'list')
    !this.type ? (this.type = this.$route.params.type) : null;
    !this.order && this.$set(this, 'loaded', true);
  },
  created(){
      setTimeout(() => this.order && this.sort(this.sortby), 1000);
  }
};
</script>
<style>
.filter-sort {
  display: flex;
}
.sort-button {
  margin: 0;
  background: rgba(0, 0, 0, 0.6);
}
.filter-button {
  margin: 0 4px 0 0;
  background: rgba(0, 0, 0, 0.6);
}
.sort-button:hover,
.filter-button:hover {
  background: rgba(0, 0, 0, 1);
}
.events-title {
  font-size: 2em;
  font-weight: 900;
}
.desc {
  height: 100px;
  overflow: hidden;
}
.add-cart {
  font-size: 1.4em;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.page-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding: 4px;
}
.page-heading h1 {
  margin: 0;
}
.page-heading input {
  font-size: 1.2em;
}
.browse-nav-button {
  background: rgba(36, 218, 187, 0.8);
  flex: 0 0 auto;
}
.browse-nav-button:hover {
  background: rgb(37, 212, 183);
}
.active-input {
  flex: 0 1 auto;
}
.time-space {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.browse-page {
  text-align: left;
  justify-content: space-around;
}
.browse-list {
  display: flex;
  flex-wrap: wrap;
  flex-direction: reverse;
}
.browse-image {
  height: auto;
  max-width: 540px;
  object-fit: cover;
}
</style>
